import { render, staticRenderFns } from "./historyTab.vue?vue&type=template&id=34d46946"
import script from "./historyTab.vue?vue&type=script&lang=js"
export * from "./historyTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports